import React from "react";
import styles from "./instafeed.module.css";
import { Border } from "../../../components/maincomps/border/Border";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { InstagramIcon } from "../../../../Svg";

const Instafeedbk = ({instagrams}) => {
    
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "ease-in-out",
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <div className={styles.sliderContainer}>
            <Border title='PAVITHRA JEWELS' subtitle='Instagram' />

            <div className={styles.imageSlider1}>
                <Slider {...settings} className={styles.customSlider}>
                    {instagrams?.map((img, index) => (
                        <div className={styles.imageItem1} key={index}>
                            <div className={styles.imagegrid}>
                                <div className={styles.imagepos}>
                                    <img src={img?.image1} alt={`Image ${index + 1}`} />
                                    <a className={styles.overlap} href={img?.buttonLink}>
                                        <InstagramIcon/>
                                    </a>
                                </div>
                                <div style={{ marginTop: "20px" }}className={styles.imagepos}>
                                    <img src={img?.image2} alt={`Image ${index + 2}`} />
                                    <a className={styles.overlap} href={img?.buttonLink}>
                                        <InstagramIcon/>
                                    </a>
                                </div>
                            </div>
                            <div className={styles.imagegrid}>
                                <div className={styles.imagepos}>
                                    <img src={img?.image2} alt={`Image ${index + 3}`} />
                                    <a className={styles.overlap} href={img?.buttonLink}>
                                        <InstagramIcon/>
                                    </a>
                                </div>
                                <div style={{ marginTop: "20px" }} className={styles.imagepos}>
                                    <img src={img?.image1} alt={`Image ${index + 4}`} />
                                    <a className={styles.overlap} href={img?.buttonLink}>
                                        <InstagramIcon/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

        </div>
    );
};

export default Instafeedbk;
